import {
} from '@/api/authorizeserv'

export default {
  state: {
  },
  mutations: {
  },
  actions: {
  },
  getters:{
  }
}